import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Zap } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0A2540] via-[#0F2A4A] to-[#0A2540] text-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-[#5750f1] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-[#5750f1] rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="space-y-8">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#5750f1]/20 rounded-2xl mb-6">
            <Zap className="w-10 h-10 text-[#5750f1]" />
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
            ¿Que esperas para llevar
            <br />
            <span className="text-[#5750f1]">tu negocio al siguiente nivel?</span>
          </h2>
          
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">            
            Con DigiStore puedes transformar tu negocio e impulsar el alcance en internet y redes. <br/> 
            Destaca en el mercado con una tienda moderna y profesional, capta nuevos clientes y aumenta tus ventas.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button 
              size="lg" 
              onClick={() => window.open('https://panel.digistore.com.ar/auth/sign-up', '_blank')}
              className="bg-[#5750f1] hover:bg-[#0042CC] text-white px-8 py-4 text-lg transition-all duration-200 transform hover:scale-105 hover:shadow-2xl"
            >
              Comienza tu prueba gratuita
              <ArrowRight className="ml-2" size={20} />
            </Button>
            
            <Button 
              size="lg" 
              variant="outline" 
              //whatsapp
              onClick={() => window.open('https://wa.me/+5492664214571?text=Hola, quisiera hablar con un asesor para conocer mas sobre DigiStore.', '_blank')}
              className="border-white text-white hover:bg-white hover:text-[#0A2540] px-8 py-4 text-lg transition-all duration-200"
            >
              Habla con un asesor
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 pt-8 text-sm text-gray-400">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full"></div>
              <span>Prueba gratuita por 3 meses</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full"></div>
              <span>No requiere tarjeta de crédito</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full"></div>
              <span>Configuración en menos de 10 minutos</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};